import { render, staticRenderFns } from "./changeStatAll.vue?vue&type=template&id=065b9bd0&"
import script from "./changeStatAll.vue?vue&type=script&lang=js&"
export * from "./changeStatAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports